export default "__VITE_ASSET__BIQi7sf2__"